import { Stack, Tooltip } from "@mui/material";
import { useSessionContext } from "../../../contexts/SessionContext";
import { useFormatter } from "../../../utils/useFormatter";
import { ResponsiveGenericTable } from "../../../components/GenericTable/ResponsiveGenericTable";
import { Check, Warning } from "@mui/icons-material";
import { ListSectionAccordion } from "./ListSectionAccordion";

export function LegalGuardianList() {
  const { guardianRelated } = useSessionContext();

  const columns = [
    { column: "Nome", rowName: "name" },
    { column: "CPF", rowName: "identifier" },
    { column: "Relação", rowName: "relationship" },
    { column: "Verificado", rowName: "active" },
    { column: "Status", rowName: "ends" },
  ];

  const rows = guardianRelated?.map((el: any) => ({
    name: useFormatter.formatNameDisplay(el?.resource?.name?.[0]?.text || ""),
    identifier: useFormatter.formatCPF(
      el?.resource?.identifier?.[0]?.value || ""
    ),
    relationship: useFormatter.translateRelationship(
      el?.resource?.relationship?.[0]?.text || ""
    ),
    active: el?.resource?.active ? (
      <Tooltip title="Verificação realizada">
        <Check color="primary" />
      </Tooltip>
    ) : (
      <>
        {el?.resource?.period?.start ? (
          <Tooltip title="Verificação pendente">
            <Warning sx={{ color: "warning500.main" }} />
          </Tooltip>
        ) : (
          <> - </>
        )}
      </>
    ),
    ends: el?.resource?.period?.end ? "Inativo" : "Ativo",
  }));

  return (
    <Stack width="100%">
      <ListSectionAccordion
        title="Lista de responsáveis legais"
        subtitle="Pessoas autorizadas a representar você ou seus dependentes"
      >
        <ResponsiveGenericTable tableColumns={columns} tableRows={rows} />
      </ListSectionAccordion>
    </Stack>
  );
}
